<div class="chart-container d-flex flex-column spacing-16" style="height: 100%">
  <div class="d-flex flex-column">
    <h3 class="h3-bold primary-100">{{ headingTitle }}</h3>
    <h4 *ngIf="subtitle" class="h4-reg primary-60">{{ subtitle }}</h4>
  </div>

  <highcharts-chart
    [Highcharts]="Highcharts"
    [options]="finalOptions()"
    style="width: 100%; display: block; flex-grow: 1; min-height: 0">
  </highcharts-chart>
</div>
